module.exports = __webpack_public_path__ + "img/home-works-2.3a21b11c.png";